import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';

import Button, {
  BUTTON_TYPES,
  BUTTON_SIZES,
  BUTTON_WIDTHS
} from 'buyside/components/presentation/Button/button';

import { CaptureSpecialPublicationUserEmailInput } from 'interfaces/graphql-typings';
const { retailUserInvestorTypes } = require('buyside/util/constantsFromRails.json');

import styles from './SpecialPublicationPreAccessFormStyles.scss';

type SpecialPublicationPreAccessFormProps = {
  onSubmit: SubmitHandler<CaptureSpecialPublicationUserEmailInput>;
  grecaptcha: () => Promise<unknown>;
  submissionError: boolean;
};

const SpecialPublicationPreAccessForm: React.FunctionComponent<SpecialPublicationPreAccessFormProps> = ({
  onSubmit,
  submissionError
}): React.ReactElement => {
  const {
    register,
    handleSubmit,
    formState,
    formState: { errors }
  } = useForm<CaptureSpecialPublicationUserEmailInput>({
    mode: 'onChange'
  });

  const investorTypes = ['Buyside Investor', ...retailUserInvestorTypes];

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <h2>Access Publication</h2>

      <label htmlFor="firstName">First Name</label>
      <input id="firstName" type="text" {...register('firstName', { required: true })} />
      {errors.firstName && <p className={styles.error}>First Name is required</p>}

      <label htmlFor="lastName">Last Name</label>
      <input id="lastName" type="text" {...register('lastName', { required: true })} />
      {errors.lastName && <p className={styles.error}>Last Name is required</p>}

      <label htmlFor="email">Email</label>
      <input id="email" type="text" {...register('email', { required: true })} />
      {errors.email && <p className={styles.error}>Email is required</p>}

      <label htmlFor="investorType">Investor Type</label>
      <>
        <select
          id="investorType"
          defaultValue={''}
          {...register('investorType', {
            required: true,
            validate: (value: string): boolean => value !== ''
          })}
        >
          <option value="" disabled>
            Select Investor Type
          </option>
          {investorTypes.map(
            (value): React.ReactElement => (
              <option key={value} value={value}>
                {value}
              </option>
            )
          )}
        </select>
      </>
      {errors.investorType && <p className={styles.error}>Investor Type is required</p>}

      <div className={styles.submitContainer}>
        <Button
          type={BUTTON_TYPES.PRIMARY}
          width={BUTTON_WIDTHS.WIDE}
          size={BUTTON_SIZES.MEDIUM}
          text="Access Document"
          isLoading={formState.isSubmitting}
        />
      </div>
      {submissionError && (
        <p className={styles.error}>
          Error submitting information. Please ensure the above fields are entered correctly.
        </p>
      )}
    </form>
  );
};

export default SpecialPublicationPreAccessForm;
